import $ from 'jquery';
import 'bootstrap-slider';

$.addInit(function(context) {
	var base = '.b-range';

	$(base, context).each(function(){
		var component = $(this);

		var slide = component.find(base + '-slider');

		var minValue = Math.floor(slide.data('slider-min'));
		var maxValue = Math.ceil(slide.data('slider-max'));

		var minInput = component.find(base + '-inputMin');
		var maxInput = component.find(base + '-inputMax');

		function getInputValue() {
			return [Math.floor(minInput.val()) || minValue, Math.ceil(maxInput.val()) || maxValue];
		}

		function setInputValue(value) {
			minInput.val(value[0] < minValue ? '' : value[0]);
			maxInput.val(value[1] > maxValue ? '' : value[1]);
		}

		function processValue(value) {
			var value = [value[0], value[1]];

			if (value[0] > value[1]) {
				value = value.reverse();
			}

			if (value[0] < minValue || value[1] > maxValue) {
				value[0] = Math.max(value[0], minValue);
				value[1] = Math.min(value[1], maxValue);
			}

			return value;
		}

		slide.slider({
			range: true,
			value: getInputValue(),
			min: minValue,
			max: maxValue,
			tooltip: 'hide',
		});

		slide.on('slide', function(e) {
			setInputValue(e.value);
		});

		minInput.add(maxInput).on('change', function() {
			var value = processValue(getInputValue());

			setInputValue(value);
			slide.slider('setValue', value);
		});
	});
});
